// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d0fdf1a0","239":"41630861","453":"060e9102","455":"6bd5c472"}[chunkId] + ".chunk.js";
};